var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 209,
    viewBox: "0 0 1440 209",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40_20553)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M859.991 -40.1965L870.929 143.322L871.155 143.326L860.209 -40.2228L859.991 -40.1965Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.12 257.221L1088.43 257.653L870.923 143.421L859.999 -40.1664L859.963 -40.5429L1088.1 257.259L1088.12 257.221ZM1087.63 256.935L860.276 -39.8543L871.191 143.22L1087.66 256.927L1087.63 256.935Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.85 -157.597L1173.06 -157.653L1088.15 257.311L1088.08 257.553L860.007 -40.1365L859.907 -40.2705L1172.82 -157.589L1172.85 -157.597ZM1172.74 -157.308L860.293 -40.1488L1087.97 257.004L1172.74 -157.308Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M868.388 133.479C862.952 134.935 859.721 140.532 861.177 145.968C862.633 151.403 868.231 154.634 873.666 153.178C879.101 151.722 882.333 146.124 880.876 140.689C879.42 135.254 873.823 132.022 868.388 133.479Z",
    fill: "#005474"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M958.555 -78.7083L958.575 -78.8745L1047.11 -38.2918L1047.23 -38.2258L898.347 237.36L958.525 -78.7002L958.555 -78.7083ZM958.777 -78.4783L898.945 235.751L1046.88 -38.0691L958.777 -78.4783Z",
    fill: "#006D86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.674 236.66L898.434 236.725L1046.97 -38.2214L1047.12 -38.5179L1111.64 207.822L1111.68 207.973L898.682 236.69L898.674 236.66ZM898.888 236.378L1111.33 207.745L1047.02 -37.7848L898.888 236.378Z",
    fill: "#006D86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.614 236.676L897.865 236.523L1111.46 207.743L1111.49 207.734L1323.85 327.272L1324.62 327.711L898.592 236.715L898.614 236.676ZM899.427 236.587L1322.99 327.052L1111.46 207.999L899.427 236.587Z",
    fill: "#006D86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.059 -252.271L579.153 -252.522L955.511 -131.867L955.587 -131.823L958.789 -78.6743L958.845 -78.464L579.029 -252.263L579.059 -252.271ZM955.349 -131.631L581.205 -251.591L958.537 -78.8963",
    fill: "#006D86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.013 -252.324L578.75 -252.704L958.719 -78.8166L958.825 -78.7806L898.77 236.538L898.692 236.849L578.975 -252.346L579.013 -252.324ZM579.492 -252.098L898.605 236.164L958.541 -78.6401L579.484 -252.128L579.492 -252.098Z",
    fill: "#006D86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.05 207.463C1102.26 202.256 1106.65 198.186 1111.85 198.4C1117.06 198.614 1121.13 202.995 1120.92 208.202C1120.7 213.409 1116.32 217.479 1111.11 217.265C1105.91 217.051 1101.84 212.671 1102.05 207.463Z",
    fill: "#006D86"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M988.2 137.391L988.25 137.699L1248.89 94.8317L1248.84 94.5235L988.2 137.391Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1248.94 94.5292L1249.42 94.755L988.22 137.707L988.13 137.731L759.066 -130.855L1248.91 94.5373L1248.94 94.5292ZM1248.31 94.6001L760.34 -129.942L988.29 137.366L1248.31 94.6001Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.921 138.015C999.653 144.46 994.24 149.483 987.773 149.253C981.329 148.984 976.305 143.571 976.536 137.104C976.805 130.66 982.218 125.637 988.684 125.867C995.129 126.136 1000.15 131.549 999.921 138.015Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1257.6 95.0096C1257.41 99.824 1253.36 103.58 1248.54 103.389C1243.73 103.199 1239.97 99.152 1240.16 94.3375C1240.36 89.5231 1244.4 85.7674 1249.22 85.9579C1254.03 86.1484 1257.79 90.1951 1257.6 95.0096Z",
    fill: "#005474"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M732.019 -18.5874L837.572 -24.8878L837.57 -25.0159L731.979 -18.7375L732.019 -18.5874Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.49 -198.658L664.564 -198.742L732.093 -18.6715L732.117 -18.5814L527.186 -13.2035L527.066 -13.1713L664.498 -198.628L664.49 -198.658ZM664.538 -198.478L527.304 -13.3638L731.911 -18.7514L664.53 -198.508L664.538 -198.478Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.009 -18.7455L732.129 -18.7777L695.878 51.5729L695.848 51.5809L527.148 -13.2255L526.829 -13.3333L732.017 -18.7155L732.009 -18.7455ZM527.494 -13.2539L695.778 51.4388L731.883 -18.6152",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M903.092 -149.846L903.33 -150.039L837.602 -24.896L731.981 -18.6095L731.771 -18.5532L903.092 -149.846ZM902.946 -149.55L732.205 -18.7339L837.54 -25.008L902.946 -149.55Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.438 52.4299C692.937 54.2917 694.841 55.3909 696.703 54.892C698.565 54.3931 699.664 52.4894 699.165 50.6275C698.666 48.7657 696.762 47.6666 694.9 48.1655C693.039 48.6643 691.94 50.5681 692.438 52.4299Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1073.51 -186.497L1073.66 -186.538L1112.27 -192.828L1112.29 -192.768L1259.75 57.2902L1259.59 57.3985L1073.52 -186.467L1073.51 -186.497ZM1112.16 -192.638L1073.87 -186.368L1258.75 55.9497L1112.19 -192.646L1112.16 -192.638Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M857.349 -92.3369L857.59 -92.4013L1073.75 -186.562L1073.77 -186.502L1259.97 57.5202L1259.66 57.4124L857.379 -92.345L857.349 -92.3369ZM1073.66 -186.311L857.862 -92.3455L1259.38 57.1004L1073.66 -186.311Z",
    fill: "#21576A"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.24
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M901.847 -6.86698L901.74 -6.06584L837.111 493.259L836.934 492.598L753.714 248.081L753.758 248.005L901.855 -6.83692L901.847 -6.86698ZM836.981 491.813L901.322 -5.34239L754.06 248.052L836.973 491.783L836.981 491.813Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.012 -6.49291L753.848 248.463L712.321 91.6792L712.441 91.647L902.004 -6.52297L902.012 -6.49291ZM753.956 247.662L901.166 -5.68686L712.664 91.877L753.926 247.67L753.956 247.662Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.23 -322.351L1240.69 -322.087L1461.89 -195.007L1469.25 145.7L1468.91 145.05L1240.19 -322.373L1240.23 -322.351ZM1461.56 -194.82L1240.96 -321.549L1468.9 144.281L1461.57 -194.79L1461.56 -194.82Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.449 -6.30978L1469.52 144.919L1469.18 145.106L836.862 492.811L836.91 492.508L901.487 -6.28786L901.449 -6.30978ZM1468.65 145.024L901.72 -5.89957L837.252 492.224L1468.68 145.016L1468.65 145.024Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.65 -322.237L1240.7 -322.027L1469.38 145.216L1469.03 145.116L901.235 -6.0274L901.443 -6.21181L1240.62 -322.229L1240.65 -322.237ZM1468.76 144.736L1240.53 -321.692L901.874 -6.16632L1468.76 144.736Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.814 -12.0953C898.122 -15.8461 903.855 -16.1915 907.605 -12.8837C911.356 -9.57587 911.702 -3.84282 908.394 -0.0920013C905.086 3.65882 899.353 4.00408 895.602 0.696273C891.851 -2.61153 891.506 -8.3445 894.814 -12.0953Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.459 84.6776C708.388 80.2451 715.161 79.8145 719.593 83.7443C724.026 87.6741 724.456 94.4463 720.526 98.8788C716.597 103.311 709.824 103.742 705.392 99.8121C700.959 95.8823 700.529 89.11 704.459 84.6776Z",
    fill: "#005474"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1076.07 22.4705L1076.44 22.404L1112.78 312.248L1112.4 312.285L1076.07 22.4705Z",
    fill: "#006D86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M719.79 -136.295L1076.45 22.3059L1076.47 22.396L1112.83 312.813L1112.43 312.375L719.76 -136.287L719.79 -136.295ZM1076.1 22.5606L721.157 -135.278L1112.31 311.698L1076.07 22.5687L1076.1 22.5606Z",
    fill: "#006D86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-56.1254 -368.331L-55.7291 -368.533L340.076 -572.529L340.169 -572.425L721.019 -135.434L720.42 -135.627L-56.1254 -368.331ZM339.979 -572.052L-55.1542 -368.43L719.929 -136.139L339.979 -572.052Z",
    fill: "#006D86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.41 34.6972C1087.17 32.4042 1090.8 25.0582 1088.51 18.3022C1086.21 11.5462 1078.87 7.91435 1072.11 10.2074C1065.36 12.5005 1061.72 19.8463 1064.02 26.6023C1066.31 33.3583 1073.66 36.9903 1080.41 34.6972Z",
    fill: "#006D86"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1461.95 -37.0878L1075.64 347.435L1075.49 347.249L964.024 219.536L964.279 219.404L1461.95 -37.0878ZM1075.65 346.756L1459.53 -35.3126L964.736 219.668L1075.65 346.756Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1518.24 333.345L1517.98 333.35L1075.09 347.323L1075.5 346.924L1460.93 -36.686L1460.98 -36.2495L1518.24 333.345ZM1076.21 346.829L1517.7 332.91L1460.58 -35.7224L1076.21 346.829Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.82 219.742L964.459 219.838L874.173 240.715L874.073 240.581L486.901 -327.867L487.273 -328.16L964.782 219.72L964.82 219.742ZM874.383 240.176L963.97 219.454L489.484 -324.955",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1461.37 -36.256L1460.86 -35.9911L964.347 219.9L964.217 219.774L486.432 -328.417L487.197 -328.204L1461.37 -36.256ZM964.451 219.325L1460.15 -36.1224L487.797 -327.528L964.421 219.334L964.451 219.325Z",
    fill: "#005474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M961.143 210.106C955.895 211.898 953.072 217.579 954.864 222.828C956.657 228.076 962.338 230.899 967.587 229.107C972.835 227.314 975.658 221.633 973.865 216.384C972.073 211.136 966.392 208.313 961.143 210.106Z",
    fill: "#005474"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.809 27.6382L422.761 27.4581L349.251 -247.244L349.371 -247.277L615.479 -228.3L615.383 -228.178L422.809 27.6382ZM349.496 -247.052L422.893 27.2296L615.135 -228.143L349.496 -247.052Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.062 27.86L422.769 27.4879L270.123 -171.392L270.183 -171.408L349.423 -247.323L349.463 -247.173L423.062 27.86ZM349.324 -246.974L270.357 -171.358L422.64 27.0074",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.14 37.881C417.358 38.0461 412.561 33.4739 412.434 27.7146C412.277 21.9633 416.841 17.1356 422.6 17.0085C428.351 16.8515 433.179 21.4157 433.306 27.175C433.471 32.9563 428.899 37.7539 423.14 37.881Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.05 -131.31L1297.89 -131.044L1220.26 -6.47742L1024.22 -9.24261L1024.6 -9.40734L1298.05 -131.31ZM1220.18 -6.6796L1297.58 -130.895L1025.08 -9.40791L1220.19 -6.64954L1220.18 -6.6796Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.25 -15.2337C1033.49 -12.1436 1033.64 -7.00308 1030.56 -3.73116C1027.47 -0.489258 1022.33 -0.334955 1019.06 -3.41704C1015.82 -6.50717 1015.66 -11.6476 1018.74 -14.9195C1021.83 -18.1614 1026.97 -18.3158 1030.25 -15.2337Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.83 -12.4758C1229.08 -9.38569 1229.23 -4.2453 1226.15 -0.973369C1223.06 2.26853 1217.92 2.42292 1214.65 -0.659162C1211.4 -3.74929 1211.25 -8.88981 1214.33 -12.1617C1217.42 -15.4036 1222.56 -15.5579 1225.83 -12.4758Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.96 -59.6292L1262.63 -59.4126L1064.96 81.9991L1065.1 81.7025L1124.12 -28.1244L1124.15 -28.1325L1262.89 -59.6432L1262.96 -59.6292ZM1065.43 81.4859L1262.24 -59.308L1124.29 -27.9764L1065.43 81.4859Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.76 -43.8531L1485.82 -43.6129L1513.68 76.3434L1395.74 191.015L1395.88 190.689L1485.79 -43.8612L1485.76 -43.8531ZM1513.51 76.2936L1485.73 -43.3324L1396.13 190.398L1513.51 76.2936Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1262.65 -59.5789L1396.09 190.858L1395.91 190.808L1065.09 81.7706L1065.22 81.6702L1262.68 -59.587L1262.65 -59.5789ZM1395.76 190.592L1262.59 -59.3365L1065.4 81.7202L1395.76 190.592Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.84 -43.6512L1485.81 -43.5451L1395.92 190.936L1395.88 190.786L1262.48 -59.5007L1262.6 -59.5329L1485.82 -43.6131L1485.84 -43.6512ZM1395.91 190.552L1485.63 -43.4968L1262.74 -59.3469L1395.88 190.56L1395.91 190.552Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1395.74 183.904C1399.51 183.795 1402.63 186.789 1402.73 190.558C1402.84 194.327 1399.85 197.446 1396.08 197.555C1392.31 197.664 1389.19 194.67 1389.08 190.901C1388.97 187.132 1391.97 184.012 1395.74 183.904Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.65 -9.32525L1024.79 -9.4255L1065.31 81.1635L1065.35 81.3137L766.153 192.285L1024.62 -9.3172L1024.65 -9.32525ZM1024.67 -9.00886L767.692 191.422L1064.99 81.1539L1024.65 -8.97075L1024.67 -9.00886Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.872 191.964L766.643 191.832L1065.14 81.1136L1065.47 81.0251L949.353 313.007L949.295 313.151L766.88 191.994L766.872 191.964ZM767.232 191.867L949.175 312.701L1064.93 81.4263L767.262 191.859L767.232 191.867Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.081 312.951L949.065 312.891L1065.05 81.1379L1065.34 80.5447L1031.61 547.096L1031.56 547.753L949.051 312.959L949.081 312.951ZM949.359 312.909L1031.44 546.436L1065.02 81.8849L949.397 312.931L949.359 312.909Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.826 191.912L766.37 191.294L949.297 312.797L1031.61 547.066L1031.89 547.891L766.796 191.92L766.826 191.912ZM767.497 192.376L1031.08 546.306L949.089 312.981L767.497 192.376Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.666 -397.272L850.89 -397.397L1058.03 -52.0946L1058.05 -52.0045L1024.83 -9.14727L1024.68 -8.97884L850.636 -397.264L850.666 -397.272ZM851.83 -395.331L1024.76 -9.51563L1057.75 -52.0523L851.83 -395.331Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.65 -397.332L850.717 -397.801L1024.86 -9.28346L1024.88 -9.19338L767.022 191.924L766.754 192.124L850.642 -397.362L850.65 -397.332ZM850.847 -396.838L767.106 191.515L1024.57 -9.27106L850.847 -396.838Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M761.693 188.492C764.027 186.032 767.894 185.929 770.324 188.271C772.784 190.605 772.887 194.472 770.544 196.902C768.21 199.362 764.343 199.465 761.913 197.123C759.454 194.789 759.351 190.922 761.693 188.492Z",
    fill: "#21576A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.68 75.0234C1062.09 71.4367 1067.78 71.2657 1071.36 74.6818C1074.95 78.098 1075.12 83.7811 1071.71 87.3679C1068.29 90.9546 1062.61 91.1256 1059.02 87.7094C1055.43 84.2933 1055.26 78.6101 1058.68 75.0234Z",
    fill: "#21576A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_20553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1539.17,
    height: 1682.08,
    fill: "white",
    transform: "translate(-235 -845.634) rotate(-15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPattern);
export default __webpack_public_path__ + "static/media/background-pattern.ef558d2f861b4ce0ec6748685c6373b5.svg";
export { ForwardRef as ReactComponent };